import { render, staticRenderFns } from "./GrupoFiliais.vue?vue&type=template&id=72cd8c6a"
import script from "./GrupoFiliais.vue?vue&type=script&lang=js"
export * from "./GrupoFiliais.vue?vue&type=script&lang=js"
import style0 from "./GrupoFiliais.vue?vue&type=style&index=0&id=72cd8c6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports